import { BaseModal } from "./BaseModal";

const ErrorModal = ({ message, onClose, closeButtonText, headerText }) => {
  return (
    <BaseModal
      isOpen={true}
      onClose={onClose}
      title={headerText || "Error"}
      footer={
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
        >
          {closeButtonText || "Got it"}
        </button>
      }
    >
      <p className="text-sm text-gray-700">{message}</p>
    </BaseModal>
  );
};

export { ErrorModal };
